import { render, staticRenderFns } from "./gamerankrecord.vue?vue&type=template&id=48477fa3"
import script from "./gamerankrecord.vue?vue&type=script&lang=js"
export * from "./gamerankrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports